import React from "react";
import { useTheme } from "@mui/material/styles";
import { useMediaQuery } from "@mui/material";

const WhatsappIcon = ({ name, shortText, color }) => {
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <a
      href={`https://wa.me/917015006321?text=Hey,\n Can I get some more info on renting a self drive ${name} in Goa?`}
      target="_blank"
      rel="noopener noreferrer"
      style={{
        paddingLeft:"10px",
        color: color?color:"white",
        textDecoration: "none",
        alignItems: "center",
      }}
    >
           <img
        src={`${process.env.PUBLIC_URL}/images/assets/WhatsApp.svg`}
        alt="WhatsApp"
        style={{
          width:'40px',
        height: 'auto',
        verticalAlign:'bottom',
        }}
      />
     <span style={{verticalAlign:'middle',  fontSize:(isSmallScreen||shortText) ?'15px':'20px'}}>{(isSmallScreen||shortText) ? "Chat" : "Chat with us"}</span>
    </a>
  );
};

export default WhatsappIcon;
